export const PRICE_RANGES = {
  HIGH: 'high',
  MID: 'mid',
  LOW: 'low',
} as const;

export type PriceRanges = ValueOf<typeof PRICE_RANGES>;
